<script setup lang="ts">
import { onMounted } from 'vue'
import VueFeather from 'vue-feather'
import { useRouter } from 'vue-router'
import { notifyError } from '@/ErrorHandler'

const router = useRouter()

const emit = defineEmits<{
  (e: 'backButton', backUrl: string|null): void
}>()

onMounted(() => {
  emit('backButton', '/')

  console.log("Not found mounted")
  notifyError('Route not found : ' + router.currentRoute.value.fullPath)
})

</script>

<template>
  <div class="container">
    <h3>Página no encontrada</h3>
    <p><VueFeather class="warn" type="alert-triangle" /></p>
    <p>La url utilizada no apunta a ningún recurso.</p>
  </div>
</template>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100%;
}
.warn {
    color: var(--main-color);
}
</style>
